import { Post, PostJson } from "../core/Helper";

export class StudyService {
  //** Get all invoice of this study */
  static async GetAllInvoice(data, user) {
    let result = await PostJson("api/document-invoice/get-study-invoices", {
      data,
      user,
    });
    return result ?? null;
  }

  static async GetHistory(params) {
    let result = await PostJson(
      "api/studyinfo/getStudyInfoOnlyHistory",
      params
    );
    return (await result) ?? null;
  }

  static async RequestOldStudyFile(params) {
    let result = await PostJson(
      "api/studyinfo/request-oldstudy-upload",
      params
    );
    return (await result) ?? null;
  }

  static async CheckFileReadyToDownload(params) {
    let result = await PostJson(
      "api/studyinfo/check-study-file-download",
      params
    );
    return (await result) ?? null;
  }

  // api/studyinfo/list-studies
  static async ListStudies(params) {
    let result = await Post("api/studyinfo/list-studies", params);
    return (await result) ?? null;
  }

  static async GetStudyListForRadi(params) {
    let result = await Post("api/studyinfo/list-studies-radiologist", params);
    return (await result) ?? null;
  }

  static async GetRadioInfoWithHistory(params) {
    let result = await Post("api/studyinfo/getStudyInfoWithHistory", params);
    return (await result) ?? null;
  }

  static async GetReportTemplateDetail(params) {
    let result = await Post("api/template-result/getdetails", params);
    return (await result) ?? null;
  }

  static async UpdateStudyResult(params) {
    let result = await Post("api/studyinfo/update-study-result-ont", params);
    return (await result) ?? null;
  }

  static async UpdateStudyResultAutoDraft(params) {
    let result = await Post("api/studyinfo/update-study-result-auto", params);
    return (await result) ?? null;
  }

  static async GetSingleStudyRadi(params) {
    let result = await Post("api/studyinfo/single-study-radiologist", params);
    return (await result) ?? null;
  }

  static async UpdateStudyStatus(params) {
    let result = await Post("api/studyinfo/update-study-status", params);
    return (await result) ?? null;
  }

  static async GetStudyComponents(params) {
    let result = await Post("api/studyinfo/getComponents", params);
    return (await result) ?? null;
  }

  static async GetStudyHistoryTracking(params) {
    let result = await Post("api/studyinfo/studies-history-tracking", params);
    return result ?? null;
  }

  static async ComfirmAlreadyAccept(params) {
    let result = await Post("api/studyinfo/confirm-accepted-study", params);
    return (await result) ?? null;
  }

  // TECHNICIAN PAGE SERVICE

  static async GetTechWorklist(params) {
    // let result = await Post("api/studyinfo/studies-update-request", params);
    // return (await result) ?? null;
    return null;
  }

  static async SaveEditorInfo(params) {
    let result = await Post("api/studyinfo/studies-update-request", params);
    return (await result) ?? null;
  }

  static async DeleteUnWantedStudy(params) {
    let result = await Post("api/studyInfo/delete-unwanted-study", params);
    return (await result) ?? null;
  }

  //api/studyInfo/update-study-verified
  static async SetVerifiedStudy(params) {
    let result = await Post("api/studyInfo/update-study-verified", params);
    return (await result) ?? null;
  }

  // reviewed study
  static async SetReviewedStudy(params) {
    let result = await Post("api/studyInfo/set-reviewed-study", params);
    return result ?? null;
  }
}
